<template>
	<div id="topMenu">
		<div class="menuBox">
			<nav class="navbar navbar-default">
			  <div class="container-fluid">
			    <!-- Brand and toggle get grouped for better mobile display -->
			    <div class="navbar-header">
			      <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
			        <span class="sr-only">Toggle navigation</span>
			        <span class="icon-bar"></span>
			        <span class="icon-bar"></span>
			        <span class="icon-bar"></span>
			      </button>
			      <a class="navbar-brand" href="#">
			      	<img src="../../assets/img/logonew.png" />
			      </a>
			    </div>

			    <!-- Collect the nav links, forms, and other content for toggling -->
			    <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
			      
			      
			      <ul class="nav navbar-nav navbar-right">
			        <li v-for="item in menuData"  v-show="item.show"><router-link :to="item.path">{{item.title}}</router-link></li>
			      </ul>
			    </div>
			  </div>
			</nav>
		</div>
	</div>
	
</template>

<script>
export default {
	data() {
		return {
			menuData:[{
				title:'首页',
				path:'/home.html',
				show:true
			},{
				title:'视频处理',
				path:'/VideoProcess.html',
				show:true
			},{
				title:'核心技术',
				path:'/Products.html',
				show:true
			},{
				title:'服务介绍',
				path:'/Service.html',
				show:true
			},{
				title:'成功案例',
				path:'/Case.html',
				show:true
			},{
				title:'关于智见',
				path:'/About.html',
				show:true
			},{
				title:'',
				path:'/DeliveryInfo.html',
				show:false
			},{
				title:'',
				path:'/InternalUseTools.html',
				show:false
			},{
				title:'',
				path:'/Login.html',
				show:false
			}]
		}
	}
}
</script>
<style lang="scss">
#topMenu{
	width: 100%;
	background-color: transparent;
	.menuBox{
		width:100%;
		max-width: 1200px;
		margin: auto;
		.navbar-brand{
			padding: 10px 10px 10px 15px;
			img{
				height: 100%;
				display: inline-block;
			}
		}
	}
}
</style>